import React from 'react'
import { LuCircleAlert } from "react-icons/lu";
import CustomButtonNew from 'Common/CustomButtonNew/CustomButtonNew';

const CardReaderAlertPopup = ({ readerName, onClose }) => {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
            <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-xl">
                <div className="flex items-start gap-4">
                    <div className="flex items-center justify-center flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full">
                        <LuCircleAlert className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1">
                        <h3 className="mb-2 text-lg font-semibold text-slate-900">
                            Payment Processing
                        </h3>
                        <p className="mb-4 text-sm text-slate-600">
                            Payment processing request has been sent to <span className="font-medium text-slate-900">{readerName}</span>. Please insert, tap, or swipe your card on the reader to securely complete your payment.
                        </p>
                        <div className="flex items-center justify-end gap-3">
                            <CustomButtonNew label="Cancel Request" onClick={onClose} />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default CardReaderAlertPopup